import { ReactNode } from "react";
export enum RequestMethod {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  DELETE = "DELETE",
  PATCH = "PATCH",
}

export type IRequestData = {
  url?: string;
  method?: RequestMethod;
  params?: Record<string, string>;
  headers?: Record<string, string>;
  config?: RequestInit;
  isRawResponse?: boolean;
  body?: FormData | Record<string, any> | string;
  statusMessageConfig?: Record<string, string | ReactNode>;
};

export type ApiResponse = Promise<{
  response;
  error: ICustomError | null;
}>;

type GetRequestData = (requestData: IRequestData) => void;

type GetResponseData = (request: IRequestData, response: Response) => void;

type GetErrorData = (request: IRequestData, error: Response | TypeError) => void;

// Each custom middleware service should implement this interface
export interface IMiddleware {
  getRequestData?: GetRequestData;
  getResponseData?: GetResponseData;
  getErrorData?: GetErrorData;
}

export type ICustomError = {
  response: any;
  message: string;
  status: number | null;
  type: "server" | "network";
};
